import { Audience, ISettings, PrivacyPolicyType, Theme } from '../../types';

export const getInitialSettings = (): ISettings => ({
  texts: {},
  appEnabled: true,
  theme: Theme.light,
  expiryDate: 0,
  privacyPolicyUrl: '',
  privacyPolicyType: PrivacyPolicyType.PageOnSite,
  privacyPolicyPage: '',
  audience: Audience.AllVisitors,
  revisitSettingsConfig: { enabled: false },
});
